export default "__VITE_ASSET__41d4c175__"